import Navbar from 'components/Navbar'
import styled from 'styled-components'

export const PageWrapper = styled.div`
  width: 100%;
  max-width: 640px;
`

export const SelectorSection = styled(Navbar.Section)`
  flex: 0 1 auto;
  /* Prevent this section from sending it's siblings of screen */
  overflow: hidden;
`
